import * as types from '../constants';
import { STATUS } from '../constants';
import { resolve } from '../api';

export const initialWidgetsState = {
  mostWidespreadTagStatus: STATUS.IDLE,
  topTrendingTagsStatus: STATUS.IDLE,
  fpAvgStatus: STATUS.IDLE,
  mostWidespreadTag: null,
  topTrendingTags: null,
  fpAvg: 0,
};

export default (state = initialWidgetsState, action) => {
  switch (action?.type) {
    case types.LOAD_MOST_WIDESPREAD_TAG: {
      return {
        ...state,
        mostWidespreadTagStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_MOST_WIDESPREAD_TAG): {
      return {
        ...state,
        mostWidespreadTagStatus: STATUS.LOADED,
        mostWidespreadTag: action?.payload,
      };
    }

    case types.LOAD_TOP_TRENDING_TAGS: {
      return {
        ...state,
        topTrendingTagsStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_TOP_TRENDING_TAGS): {
      return {
        ...state,
        topTrendingTagsStatus: STATUS.LOADED,
        topTrendingTags: action?.payload,
      };
    }

    case types.LOAD_FP_AVG: {
      return {
        ...state,
        fpAvgStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_FP_AVG): {
      return {
        ...state,
        fpAvgStatus: STATUS.LOADED,
        fpAvg: action?.payload?.total_avg,
      };
    }

    default:
      return state;
  }
};
